export enum FormType {
  Unknown = 'Unknown',
  TireCount = 'TireCount',
  CurbAppeal = 'CurbAppeal',
  Incident = 'Incident',
  CashDrawer = 'CashDrawer',
  ShowroomInspection = 'ShowroomInspection'
}
